module.exports = __webpack_public_path__ + "static/media/rounding-monitor-logo.138af157.svg";